<template lang='pug'>
div(
  v-if='uid'
  :key='uid'
)
  slot(
    :uid='uid'
  )
</template>

<script>
import { cond, get, identity, pipe } from 'lodash/fp'

import {
  app,
} from '../functions/initializeApp'

import {
  ensureUser,
} from '../functions/ensureUser'

import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth'

const mounted = async function ()
{
  await ensureUser()

  const auth = getAuth(app)

  onAuthStateChanged
  (
    auth,
    pipe
    ([
      get('uid'),
      cond([[identity, uid => this.uid = uid]]),
    ])
  )
}

export default
{
  data()
  {
    return {
      uid: null
    }
  },
  mounted,
}
</script>